import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router";
import Cookies from "universal-cookie";
import "./Navbar.css";
import ProfilePic from "./nopfp.png";
import SearchIcon from "../../Customer/AddCustomers/Icons/Search.svg";
import gear from "./IconsNavbar/gear.png";
import gearwit from "./IconsNavbar/gear-white.png";
import AppStore from "./IconsNavbar/AppStore.svg";
import AppStorewit from "./IconsNavbar/AppStore-white.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightFromBracket,
  faUsersGear,
  faCaretDown,
  faRepeat,
  faBars,
  faXmark,
  faHome,
  faBox,
  faShoppingCart,
  faUsers,
  faCog,
  faStore,
  faFileImport,
} from "@fortawesome/free-solid-svg-icons";
import {
  faAddressCard,
} from "@fortawesome/free-regular-svg-icons";
import middleware from "../../Api/Middleware";
import ResetDemoModal from "../../Modals/ResetDemoModal";
import { Link } from "react-router-dom";
import { UnderlineSearchBar } from '../../HouseStyle/Components/SearchBars.js';
import function_config from "../../../config.js";

const Navbar = ({ navInfo, title, callbackFuncIsLoading, sidebarsmall, hideBackButton }) => {

  const cookies = new Cookies();
  const navigate = useNavigate();

  const [focused, setFocused] = useState(false);
  const [isMobileSearchExpanded, setIsMobileSearchExpanded] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const dropdownContentRef = useRef(null);
  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);
  const [containerWidth, setContainerWidth] = useState("auto");
  const lineRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [isResetting, setIsResetting] = useState(false);
  const [sideBarLinks, setSideBarLinks] = useState([]);
  
  // Search functionality states
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const searchResultsRef = useRef(null);
  const [isMenuClosing, setIsMenuClosing] = useState(false);

  // Available routes for search with role requirements
  const routes = [
    { path: "/", label: "Dashboard", minRole: 0, searchTerms: [], icon: faHome },
    { path: "/producten", label: "Warehouse HUB", minRole: 0, searchTerms: ["producten", "products"], icon: faBox },
    { path: "/producten/nieuw", label: "Nieuw Product", minRole: 0, searchTerms: [], icon: faBox },
    { path: "/producten/nieuw/variatie", label: "Nieuw Variatie Product", minRole: 0, searchTerms: ["variation", "variant"], icon: faBox },
    { path: "/bestellingen", label: "Order HUB", minRole: 0, searchTerms: ["bestellingen", "orders"], icon: faShoppingCart },
    { path: "/bestellingen/nieuw", label: "Nieuwe Bestelling", minRole: 0, searchTerms: ["order"], icon: faShoppingCart },
    { path: "/klanten", label: "Customer HUB", minRole: 0, searchTerms: ["klanten", "customers", "clients", "clienten"], icon: faUsers },
    { path: "/klanten/bewerken", label: "Klanten Bewerken", minRole: 0, searchTerms: ["bewerken", "edit", "wijzigen", "modify"], icon: faUsers },
    { path: "/algemene/instellingen", label: "Algemene Instellingen", minRole: 4, searchTerms: ["instellingen", "settings", "configuratie", "config"], icon: faCog },
    { path: "/algemene/instellingen/gebruikers", label: "Gebruikers Beheren", minRole: 4, searchTerms: ["gebruikers", "users", "beheren", "manage"], icon: faUsersGear },
    { path: "/profiel", label: "Mijn Profiel", minRole: 0, searchTerms: ["profile", "account"], icon: faAddressCard },
    { path: "/appstore", label: "App Store", minRole: 0, searchTerms: ["apps", "applicaties"], icon: faStore },
    { path: "/import-export-center", label: "Import Export Center", minRole: 0, searchTerms: ["centrum"], icon: faFileImport },
  ];

  // Check if mobile view
  const isMobile = windowSize[0] <= 768;

  useEffect(() => {
    if (navInfo && navInfo.routes) {
      try {
        const formattedRoutes = navInfo.routes.map(route => ({
          to: route.to,
          text: route.text,
          icon: route.icon,
          status: route.status
        }));
        setSideBarLinks(formattedRoutes);
      } catch (error) {
        console.error('Error parsing navInfo.routes:', error);
      }
    }
  }, [navInfo]);

  // Toggle mobile menu
const toggleMobileMenu = () => {
  if (isMobileMenuOpen) {
    // Start closing animation
    setIsMenuClosing(true);
    // Wait for animation to complete before actually closing
    setTimeout(() => {
      setIsMobileMenuOpen(false);
      setIsMenuClosing(false);
      document.body.style.overflow = 'auto';
    }, 300); // Match animation duration
  } else {
    setIsMobileMenuOpen(true);
    document.body.style.overflow = 'hidden';
  }
};

  // Close mobile menu and navigate
const handleMobileNavigation = (path) => {
  setIsMenuClosing(true);
  setTimeout(() => {
    setIsMobileMenuOpen(false);
    setIsMenuClosing(false);
    document.body.style.overflow = 'auto';
    navigate(path);
  }, 300);
};

  // Toggle mobile search expansion
  const toggleMobileSearch = () => {
    setIsMobileSearchExpanded(!isMobileSearchExpanded);
    if (!isMobileSearchExpanded) {
      setFocused(true);
    }
  };

  // Search function with role-based filtering
  const handleSearch = (query) => {
    setSearchQuery(query);
    
    if (query.trim() === "") {
      setSearchResults([]);
      setShowSearchResults(false);
      return;
    }
    
    const userRole = navInfo?.role || 0;
    const filteredResults = routes.filter(route => {
      const matchesRole = userRole >= route.minRole;
      const queryLower = query.toLowerCase();
      const matchesLabel = route.label.toLowerCase().includes(queryLower);
      const matchesSearchTerms = route.searchTerms?.some(term => 
        term.toLowerCase().includes(queryLower)
      );
      
      return matchesRole && (matchesLabel || matchesSearchTerms);
    });
    
    setSearchResults(filteredResults);
    setShowSearchResults(true);
  };

  // Handle click on search result
  const handleResultClick = (path) => {
    navigate(path);
    setSearchQuery("");
    setSearchResults([]);
    setShowSearchResults(false);
    setIsMobileSearchExpanded(false);
    setIsMobileMenuOpen(false);
    document.body.style.overflow = 'auto';
  };

  // Keyboard shortcuts and event listeners
  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === 'f') {
        event.preventDefault();
        if (isMobile) {
          setIsMobileSearchExpanded(true);
        }
        setFocused(true);
        setShowSearchResults(searchResults.length > 0);
      }
      
      if (event.key === 'Enter' && showSearchResults && searchResults.length > 0) {
        event.preventDefault();
        handleResultClick(searchResults[0].path);
      }
      
      if (event.key === 'Escape') {
        if (isMobileMenuOpen) {
          setIsMobileMenuOpen(false);
          document.body.style.overflow = 'auto';
        }
        if (isMobileSearchExpanded) {
          setIsMobileSearchExpanded(false);
          setSearchQuery("");
          setShowSearchResults(false);
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [searchResults, showSearchResults, isMobile, isMobileSearchExpanded, isMobileMenuOpen]);

  // Cleanup body overflow on unmount
  useEffect(() => {
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  // Reset focused state after it triggers the focus
  useEffect(() => {
    if (focused) {
      const timer = setTimeout(() => {
        setFocused(false);
      }, 100);
      
      return () => clearTimeout(timer);
    }
  }, [focused]);

  // Close search results when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.closest('.search-result-item')) {
        return;
      }
      
      if (searchResultsRef.current && !searchResultsRef.current.contains(event.target)) {
        setShowSearchResults(false);
        if (isMobile && !event.target.closest('.mobile-search-icon')) {
          setIsMobileSearchExpanded(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMobile]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutsideDropdown = (event) => {
      if (dropdownContentRef.current && 
          !dropdownContentRef.current.contains(event.target) &&
          !event.target.closest('.userInfoMenu')) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutsideDropdown);
    }
    return () => document.removeEventListener("mousedown", handleClickOutsideDropdown);
  }, [showDropdown]);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
      // Close mobile menu if screen becomes larger
      if (window.innerWidth > 768 && isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
        document.body.style.overflow = 'auto';
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobileMenuOpen]);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

const logout = () => {
  const token = cookies.get('token');
  localStorage.removeItem(`navInfo[${token}]`);
  cookies.remove("token", { path: "/" });
  
  if (isMobileMenuOpen) {
    setIsMenuClosing(true);
    setTimeout(() => {
      document.body.style.overflow = 'auto';
      navigate("/login");
    }, 300);
  } else {
    navigate("/login");
  }
};

  const handleResetDemo = async () => {
    setIsResetting(true);
    try {
      const response = await middleware.post("/reset-demo");
      if (response.status === 200) {
        alert("Demo omgeving succesvol gereset!");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error resetting demo environment:", error);
      alert("Er is een fout opgetreden bij het resetten van de demo omgeving.");
    } finally {
      setIsResetting(false);
    }
  };

  useEffect(() => {
    callbackFuncIsLoading(false);
  }, []);

  useEffect(() => {
    if (dropdownContentRef.current) {
      const container = dropdownContentRef.current.previousSibling;
      setContainerWidth(`${container.offsetWidth}px`);
    }
  }, [showDropdown]);

  useEffect(() => {
    if (lineRef.current) {
      lineRef.current.style.width = "249px";
    }
  }, [containerWidth]);

  return (
    <>
      {/* Mobile Fullscreen Menu */}
      {isMobile && isMobileMenuOpen && (
        <div className={`mobile-fullscreen-menu ${isMenuClosing ? 'closing' : ''}`}>
          <div className="mobile-menu-header">
            <div className="mobile-menu-profile">
              <img
                src={navInfo?.profile_picture_url || ProfilePic}
                alt="Profiel"
                className="mobile-menu-profile-pic"
              />
              <div className="mobile-menu-user-info">
                <p className="mobile-menu-user-name">
                  {navInfo?.first_name || 'Gebruiker'} {navInfo?.last_name || ''}
                </p>
                <p className="mobile-menu-user-role">
                  {navInfo?.role >= 4 ? 'Beheerder' : 'Gebruiker'}
                </p>
              </div>
            </div>
            <button 
              className="mobile-menu-close-btn"
              onClick={toggleMobileMenu}
              aria-label="Menu sluiten"
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>

          {/* Navigation items */}
          <nav className="mobile-menu-nav">
            {sideBarLinks
              .filter(link => link.status === 1 || link.status === "1") // Only show active links
              .map((link, index) => (
                <div
                  key={index}
                  className="mobile-menu-nav-item"
                  onClick={() => handleMobileNavigation(link.to)}
                >
                  <img 
                    src={link.icon ?? "https://static.thenounproject.com/png/482114-200.png"} 
                    alt={link.text}
                    className="mobile-menu-nav-icon-img"
                  />
                  <span>{link.text}</span>
                </div>
              ))}

              {/* Divider */}
              <div className="mobile-menu-divider"></div>

              {/* <div
                className="mobile-menu-nav-item"
                onClick={() => handleMobileNavigation('/appstore')}
              >
                <img 
                  src={AppStorewit} 
                  alt="App Store"
                  className="mobile-menu-nav-icon-img icon-white"
                />
                <span>App Store</span>
              </div>

              {navInfo?.role >= 4 && (
                <div
                  className="mobile-menu-nav-item"
                  onClick={() => handleMobileNavigation('/algemene/instellingen')}
                >
                  <img 
                    src={gearwit} 
                    alt="Instellingen"
                    className="mobile-menu-nav-icon-img icon-white"
                  />
                  <span>Instellingen</span>
                </div>
              )} */}
          </nav>

          {/* Bottom section with profile and logout */}
          <div className="mobile-menu-bottom">
            {/* <div 
              className="mobile-menu-nav-item"
              onClick={() => handleMobileNavigation('/profiel')}
            >
              <FontAwesomeIcon icon={faAddressCard} className="mobile-menu-nav-icon" />
              <span>Mijn Profiel</span>
            </div>
            
            {navInfo?.role >= 4 && (
              <div 
                className="mobile-menu-nav-item"
                onClick={() => handleMobileNavigation('/algemene/instellingen/gebruikers')}
              >
                <FontAwesomeIcon icon={faUsersGear} className="mobile-menu-nav-icon" />
                <span>Gebruikers Beheren</span>
              </div>
            )}
            
            {navInfo?.role >= 4 && (
              <div 
                className="mobile-menu-nav-item"
                onClick={() => {
                  setIsMenuClosing(true);
                  setTimeout(() => {
                    setIsMobileMenuOpen(false);
                    setIsMenuClosing(false);
                    document.body.style.overflow = 'auto';
                    setShowResetModal(true);
                  }, 300);
                }}
              >
                <FontAwesomeIcon icon={faRepeat} className="mobile-menu-nav-icon" />
                <span>Reset Demo omgeving</span>
              </div>
            )} */}

            <div 
              className="mobile-menu-nav-item mobile-menu-logout"
              onClick={logout}
            >
              <FontAwesomeIcon icon={faArrowRightFromBracket} className="mobile-menu-nav-icon" />
              <span>Uitloggen</span>
            </div>
          </div>
        </div>
      )}

      {/* Mobile Search Overlay */}
      {isMobile && isMobileSearchExpanded && !isMobileMenuOpen && (
        <div className="mobile-search-overlay" onClick={(e) => {
          if (e.target === e.currentTarget) {
            setIsMobileSearchExpanded(false);
            setSearchQuery("");
            setShowSearchResults(false);
          }
        }}>
          <div className="mobile-search-expanded-container">
            <div className="mobile-search-header">
              <UnderlineSearchBar
                placeholder={"Zoeken naar pagina"}
                size='l'
                value={searchQuery}
                searchFunction={handleSearch}
                focused={focused}
                searchDelayTimer={0}
              />
              <button 
                className="mobile-search-close"
                onClick={() => {
                  setIsMobileSearchExpanded(false);
                  setSearchQuery("");
                  setShowSearchResults(false);
                }}
              >
                ✕
              </button>
            </div>
            
            {showSearchResults && searchResults.length > 0 && (
              <div className="mobile-search-results" ref={searchResultsRef}>
                {searchResults.map((result, index) => (
                  <div 
                    key={index} 
                    className="search-result-item" 
                    onClick={(e) => {
                      e.stopPropagation();
                      handleResultClick(result.path);
                    }}
                  >
                    {result.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      <nav
        className={`${sidebarsmall === true ? "navbarSmall navbar" : "navbar"} ${windowSize[0] < 1458 ? " navbarSmall" : ""
          } ${isMobile ? "navbar-mobile" : ""} pe-5 ps-5 col-lg-10 d-flex flex-row flex-nowrap justify-content-between`}
      >
        {/* Mobile: Hamburger menu button */}
        {isMobile && (
          <button 
            className="hamburger-btn"
            onClick={toggleMobileMenu}
            aria-label="Menu openen"
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
        )}

        <div className="d-flex flex-row justify-content-center align-items-center">
          <h2 className="mb-0 pageTitle text-nowrap fw-bold">
            {title !== null ? title : ""}
          </h2>
        </div>

        <div className="iconHeightNav d-flex pt-1">
          <div className="iconBox me-3 d-flex flex-row">
            <div className={`d-flex flex-nowrap position-relative`}>
              {/* Desktop search - hidden on mobile */}
              <div className={`align-self-center pe-3 search-container ${isMobile ? 'd-none' : 'd-flex'}`}>
                <UnderlineSearchBar
                  placeholder={"Zoeken naar pagina"}
                  size='l'
                  value={searchQuery}
                  searchFunction={handleSearch}
                  focused={focused}
                  searchDelayTimer={0}
                />
                
                {showSearchResults && searchResults.length > 0 && (
                  <div className="search-results-dropdown" ref={searchResultsRef}>
                    {searchResults.map((result, index) => (
                      <div 
                        key={index} 
                        className="search-result-item" 
                        onClick={() => handleResultClick(result.path)}
                      >
                        {result.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Mobile search icon */}
              {isMobile && (
                <div className="mobile-search-wrapper d-flex align-items-center">
                  <img 
                    src={SearchIcon} 
                    className="mobile-search-icon iconsNav user-select-none" 
                    onClick={toggleMobileSearch}
                    role="button"
                    alt="Zoeken"
                  />
                </div>
              )}
            </div>

            {/* Desktop indicator icons - hidden on mobile */}
            {!isMobile && (
              <div className="indicatorIcons">
                {navInfo?.role >= 4 && (
                  <Link to={"/algemene/instellingen"}>
                    <img
                      role="button"
                      src={gear}
                      className="iconsNav user-select-none"
                      alt="Instellingen"
                    />
                  </Link>
                )}
                <Link to={"/appstore"}>
                  <img
                    role="button"
                    src={AppStore}
                    className="iconsNav user-select-none"
                    alt="App Store"
                  />
                </Link>
              </div>
            )}
          </div>

          {/* Desktop user dropdown - hidden on mobile */}
          {!isMobile && (
            <div className={`dropdownNav ps-4 ${showDropdown ? "clicked" : ""}`}>
              <div
                className="userInfoMenu hover d-flex flex-row"
                onClick={toggleDropdown}
              >
                <div className="profile-container d-flex align-items-center">
                  <div className="profile-picture">
                    <img
                      src={navInfo?.profile_picture_url || ProfilePic}
                      alt="Profiel"
                      className="profile-picture user-select-none"
                    />
                  </div>
                  <p className="fw-bold mb-4 text-nowrap userName">
                    {`Hallo, ${navInfo?.first_name
                      ? navInfo?.first_name +
                      " " +
                      (navInfo?.last_name ? navInfo?.last_name : "")
                      : "Gebruiker"
                      }`}
                  </p>
                </div>
                <FontAwesomeIcon
                  className={`px-1 dropdownIndicator ${showDropdown ? "rotate" : ""}`}
                  icon={faCaretDown}
                />
              </div>
              <div className="hover-area" onClick={toggleDropdown}></div>
              <div
                className="dropdown-content"
                style={{
                  display: showDropdown ? "flex" : "none",
                  width: "249px",
                }}
                ref={dropdownContentRef}
              >
                <div className="dropdown-profile-header d-flex align-items-center p-3 border-bottom">
                  <img
                    src={navInfo?.profile_picture_url || ProfilePic}
                    alt="Profiel"
                    className="dropdown-profile-pic me-2"
                    style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }}
                  />
                  <div>
                    <p className="fw-bold mb-0" style={{ fontSize: '14px' }}>
                      {navInfo?.first_name || 'Gebruiker'} {navInfo?.last_name || ''}
                    </p>
                  </div>
                </div>
                <div className="menuListedItems w-100" role="menuitem">
                  <div className="navbarDropDownItem" onClick={() => navigate("/profiel")}>
                    <FontAwesomeIcon icon={faAddressCard} className="me-2" />
                    Mijn profiel
                  </div>
                  {navInfo?.role >= 4 &&
                    <div className="navbarDropDownItem" onClick={() => navigate("/algemene/instellingen/gebruikers")}>
                      <FontAwesomeIcon icon={faUsersGear} className="me-2" />
                      Gebruikers Beheren
                    </div>
                  }
                  {navInfo?.role >= 4 &&
                    <div className="navbarDropDownItem" onClick={() => setShowResetModal(true)}>
                      <FontAwesomeIcon icon={faRepeat} className="me-2" />
                      Reset Demo omgeving
                    </div>
                  }
                </div>
                <p className="line" ref={lineRef}></p>
                <div className="logOut d-flex flex-nowrap" onClick={logout}>
                  <FontAwesomeIcon
                    icon={faArrowRightFromBracket}
                    className="logOutIcon"
                  />
                  <p className="text-black logOutText fw-semibold">Uitloggen</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </nav>

      <ResetDemoModal
        showModal={showResetModal}
        setShowModal={setShowResetModal}
        onConfirmReset={handleResetDemo}
        isLoading={isResetting}
      />
    </>
  );
};

export default Navbar;